export default __webpack_public_path__ + "static/bg-footer-cd307a0dc0207a4bdf2f12fb42afb387.png";